import { render, staticRenderFns } from "./NotificationResult-Second.vue?vue&type=template&id=422aa510&scoped=true"
import script from "./NotificationResult-Second.vue?vue&type=script&lang=js"
export * from "./NotificationResult-Second.vue?vue&type=script&lang=js"
import style0 from "./NotificationResult-Second.vue?vue&type=style&index=0&id=422aa510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422aa510",
  null
  
)

export default component.exports